import { DashboardType } from "@/types/content";

import { AssetManagementDashboard } from "@/components/dashboard/AssetManagementDashboard";
import { CRMDashboard } from "@/components/dashboard/CRMDashboard";
import { EducationDashboard } from "@/components/dashboard/EducationDashboard";
import { ERPDashboard } from "@/components/dashboard/ERPDashboard";
import { GenericDashboard } from "@/components/dashboard/GenericDashboard";
import { HealthcareDashboard } from "@/components/dashboard/HealthcareDashboard";
import { LogisticsDashboard } from "@/components/dashboard/LogisticsDashboard";
import { RetailDashboard } from "@/components/dashboard/RetailDashboard";

interface Props {
    dashboard: DashboardType;
    accent: string;
}

export function CaseStudyHero({
    dashboard,
    accent,
}: Props) {

    switch (dashboard) {

        case "asset":
            return (
                <AssetManagementDashboard
                    accent={accent}
                />
            );

        case "erp":
            return (
                <ERPDashboard
                    accent={accent}
                />
            );

        case "healthcare":
            return (
                <HealthcareDashboard
                    accent={accent}
                />
            );

        case "crm":
            return (
                <CRMDashboard
                    accent={accent}
                />
            );

        case "education":
            return (
                <EducationDashboard
                    accent={accent}
                />
            );

        case "logistics":
            return (
                <LogisticsDashboard
                    accent={accent}
                />
            );

        case "retail":
            return (
                <RetailDashboard
                    accent={accent}
                />
            );

        default:
            return (
                <GenericDashboard
                    accent={accent}
                />
            );
    }
}